import { Component, OnInit } from '@angular/core';
import { PromosService } from './../../services/promos/promos.service';
// import { Promo } from '../../models/promo';

@Component({
  selector: 'app-promo-list',
  templateUrl: './promo-list.component.html',
  styleUrls: ['./promo-list.component.scss'],
})
export class PromoListComponent implements OnInit {
  public promos;

  constructor(private _promoService: PromosService) {}

  ngOnInit() {
    this._promoService.getPromos().then(promos => {
      this.promos = promos;
      console.log('promos', this.promos);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-list/promo-list.component.ts